import { Box, TableCell, TableHead, TableRow, TableSortLabel, Typography } from '@mui/material';
import { ExportProps, ReportsProps } from "features/report/report-constants";
import _ from 'lodash';
import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import { numberFormat, toBuddhistYear } from 'utils/app.utils';

/** TRANSLATION */
import { useTranslation } from 'react-i18next';

import TableRowExport from 'component/Pdf/TableRowExport';
import TableCustom from 'component/Table/TableCustom';
import TableRowCommon from 'component/Table/TableRowCommon';

/** STYLE */
import { colors } from 'constants/theme';
import * as UseStyled from 'features/report/useStyled';

import LabReportListTotal from './LabReportListTotal';

import { UseSnCode } from 'utils/useSnCode';
export const dfLabConfig: ReportsProps = {
    key: 'DF_LAB',
    textName: 'DF_LAB',
    portrait: false,
    renderDataCustom: false,
    filter: {
        branch: true,
        date: true,
        rangeDate: false,
        prefix: false,
        receiptStatus: false,
        operativeType: false,
        billStatus: false,
        operativeCode: false,
        doctor: true,
        patient: false,
    },
    export: {
        pdf: true,
        excel: true
    }
}

export interface FcComponent {
    date: any
    page: number
    pageLimit: number
    rowCount: number
    sortBy: string
    sortType: string
    data: any
    onRequestSort: (sortBy: string, sortType: string) => void
    handleChangeRowsPerPage: (val: any) => void
    handleChangePage: (val: any) => void
    componentRef: any
    filter: any
}

export default function LabReportList(props: FcComponent) {
    const { t } = useTranslation()

    const [snType, setSnType] = useState(false);

    const handleSnCode = useCallback(() => {
        const fetchData = async () => {
            const sn = await UseSnCode();
            setSnType(sn);
        };

        fetchData();

    }, [snType]);

    useEffect(() => {
        handleSnCode()
    }, [])
    const headDfCells = [
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.LAB.#NO', align: 'center', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.LAB.DENTIST', align: 'left', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.LAB.PATIENI_CODE', align: 'left', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.LAB.SN_CODE', align: 'left', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.LAB.PATIENT_NAME', align: 'left', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.LAB.LAB_COMPANY', align: 'left', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.LAB.LAB_GROUP', align: 'right', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.LAB.LAB_NAME', align: 'right', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.LAB.REMARK', align: 'right', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.LAB.LAB_TX', align: 'right', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.LAB.LAB_FEE', align: 'right', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.LAB.DF_PERCENT', align: 'right', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.LAB.DF_LAB_FEE', align: 'right', class: 'text-nowrap' },

    ]

    if (!snType) {
        headDfCells.splice(3, 1)
    }
    const renderDataDF = (data: any, no: number, exportData: boolean, render: 'data' | 'sum') => {
        if (render === 'data') {
            const { branchCnNumber, snCode, dateOrder, doctorName, labClinicPercent, labClinicTotal, labCompanyName, labDoctorPercent, labDoctorTotal, labGroupName, labName, labOrderId, labOrderPrice, labRemark, operativeName, patientName } = data
            const num = exportData === true ? no + 1 : props.page * props.pageLimit - props.pageLimit + no + 1
            const objRenderData = {
                key: num.toString(),
                id: no.toString(),
                obj: data,
                columns: [
                    { option: 'TEXT', align: 'center', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: num, class: 'text-nowrap' },
                    { option: 'TEXT', align: 'left', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: doctorName || '-', class: 'text-nowrap' },
                    { option: 'TEXT', align: 'left', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: branchCnNumber || '-', class: 'text-nowrap' },
                    { option: 'TEXT', align: 'left', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: snCode || '-', class: 'text-nowrap' },
                    { option: 'TEXT', align: 'left', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: patientName || '-', class: 'text-nowrap' },
                    { option: 'TEXT', align: 'left', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: labCompanyName || '-', class: 'text-nowrap' },
                    { option: 'TEXT', align: 'left', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: labGroupName || '-', class: 'text-nowrap' },
                    { option: 'TEXT', align: 'left', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: labName || '-', class: 'text-nowrap' },
                    { option: 'TEXT', align: 'left', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: labRemark || '-', class: 'text-nowrap' },
                    { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: operativeName, class: 'text-nowrap' },
                    { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: numberFormat(labOrderPrice || 0), class: 'text-nowrap' },
                    { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: `${Number(labDoctorPercent || 0)}%`, class: 'text-nowrap' },
                    { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: numberFormat(labDoctorTotal || 0), class: 'text-nowrap' },

                ]
            }
            if (!snType) {
                objRenderData.columns.splice(3, 1)
            }
            return (
                <>
                    {exportData === true && <TableRowExport {...objRenderData} /> ||
                        <TableRowCommon  {...objRenderData} />
                    }
                </>
            )
        } else {
            const objRenderData = {
                key: no.toString(),
                id: no.toString(),
                obj: data,
                columns: [
                    { option: 'MERGE', align: 'center', colSpan: snType ? 9 : 8 },
                    { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: <Typography sx={{ fontWeight: 500, fontSize: exportData ? 10 : 16 }}>{t('REPORT.TITLE.SUM')}</Typography>, class: 'text-nowrap' },
                    { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: numberFormat(_.sumBy(data, 'labOrderPrice')), class: 'text-nowrap' },
                    { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: '', class: 'text-nowrap' },
                    { option: 'TEXT', align: 'right', style: { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }, label: numberFormat(_.sumBy(data, 'labDoctorTotal')), class: 'text-nowrap' },

                ],
                classes: 'row-summary'
            }

            return (
                <>
                    {exportData === true && <TableRowExport {...objRenderData} /> ||
                        <TableRowCommon  {...objRenderData} />
                    }
                </>
            )
        }
    }


    const sumTotal = (handInsurance: number, df: number, lab: number) => {
        if (df > handInsurance) {
            return numberFormat(df - lab)
        } else {
            return numberFormat(handInsurance - lab)
        }
    }

    return (
        <>
            <Box>
                <UseStyled.ResponsiveReportTable className='mt-2' verticalAlign='top'>
                    <TableCustom
                        customScroll
                        hidePagination
                        page={props.page}
                        pageLimit={props.pageLimit}
                        sortType={props.sortType}
                        sortBy={props.sortBy}
                        rowCount={props.rowCount}
                        onSort={props.onRequestSort}
                        setPageLimit={props.handleChangeRowsPerPage}
                        setPage={props.handleChangePage}
                        headCells={headDfCells}
                        rowsData={
                            _.map(_.groupBy(props.data, 'dateOrder'), (data: any, index: any) => {
                                return !_.isEmpty(data) ? [
                                    <TableRow key={`date-${index}`}>
                                        <TableCell colSpan={_.size(headDfCells)} sx={{ fontWeight: '500 !important' }}>
                                            <span className='mr-2'>{t('MOMENT_AT')}</span>
                                            {toBuddhistYear(moment(index), 'DD/MM/YYYY')}
                                        </TableCell>
                                    </TableRow>,

                                    _.map(data, (lab: any, indexTable: number) => {
                                        return renderDataDF(lab, indexTable, false, 'data')
                                    }),
                                    renderDataDF(data, 0, false, 'sum')
                                ] : []
                            })
                        }
                    />
                </UseStyled.ResponsiveReportTable>
                <Box className='mt-3 pl-xl-3 pr-xl-2 pb-4'>
                    <LabReportListTotal
                        type={"html"}
                        date={props.date}
                        page={props.page}
                        pageLimit={props.pageLimit}
                        sortType={props.sortType}
                        sortBy={props.sortBy}
                        rowCount={props.rowCount}
                        data={props.data}
                        onRequestSort={props.onRequestSort}
                        handleChangeRowsPerPage={props.handleChangeRowsPerPage}
                        handleChangePage={props.handleChangePage}
                    />
                </Box>
            </Box>
            <Box
                id="print-table-container"
                ref={props.componentRef}
            >
                <Typography fontSize="14px" fontWeight={400}>{t('REPORT.REPORT_NAME.LAB')}</Typography>
                <Box display='flex' flexDirection="row" alignItems="center" gap="16px">
                    <Typography fontSize="10px" fontWeight={400}>{t('REPORT.FILTER.BRANCH')}: {props.filter[0]}</Typography>
                    <Typography fontSize="10px" fontWeight={400}>{t('REPORT.FILTER.DATE_START')}: {toBuddhistYear(moment(props.filter[1]), 'DD/MM/YYYY')}</Typography>
                    <Typography fontSize="10px" fontWeight={400}>{t('REPORT.FILTER.DATE_END')}: {toBuddhistYear(moment(props.filter[2]), 'DD/MM/YYYY')}</Typography>
                    <Typography fontSize="10px" fontWeight={400}>{t('REPORT.FILTER.DOCTOR')}: {props.filter[3]}</Typography>
                    <Typography fontSize="10px" fontWeight={400}>{t('REPORT.FILTER.LAB_GROUP')}: {props.filter[4]}</Typography>
                    <Typography fontSize="10px" fontWeight={400}>{t('REPORT.FILTER.LAB_COMPANY')}: {props.filter[5]}</Typography>
                </Box>
                <table style={{ width: '100%', border: '1px solid black', borderCollapse: 'collapse', marginTop: '16px' }}>
                    <thead>
                        <tr style={{ textAlign: 'center', fontSize: '9.5px', fontWeight: 700 }}>
                            <th style={{ borderBottom: '1px solid black' }}>{t('REPORT.TABLE.LAB.#NO')}</th>
                            <th style={{ borderBottom: '1px solid black', textAlign: 'center' }}>{t('REPORT.TABLE.LAB.DENTIST')}</th>
                            <th style={{ borderBottom: '1px solid black', textAlign: 'center' }}>{t('REPORT.TABLE.LAB.PATIENI_CODE')}</th>
                            {snType && <th style={{ borderBottom: '1px solid black', textAlign: 'center' }}>{t('REPORT.TABLE.LAB.SN_CODE')}</th>}
                            <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('REPORT.TABLE.LAB.PATIENT_NAME')}</th>
                            <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('REPORT.TABLE.LAB.LAB_COMPANY')}</th>
                            <th style={{ borderBottom: '1px solid black', textAlign: 'center' }}>{t('REPORT.TABLE.LAB.LAB_GROUP')}</th>
                            <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('REPORT.TABLE.LAB.LAB_NAME')}</th>
                            <th style={{ borderBottom: '1px solid black', textAlign: 'center' }}>{t('REPORT.TABLE.LAB.REMARK')}</th>
                            <th style={{ borderBottom: '1px solid black', textAlign: 'center' }}>{t('REPORT.TABLE.LAB.LAB_TX')}</th>
                            <th style={{ borderBottom: '1px solid black', textAlign: 'right' }}>{t('REPORT.TABLE.LAB.LAB_FEE')}</th>
                            <th style={{ borderBottom: '1px solid black', textAlign: 'right' }}>{t('REPORT.TABLE.LAB.DF_PERCENT')}</th>
                            <th style={{ borderBottom: '1px solid black', textAlign: 'right' }}>{t('REPORT.TABLE.LAB.DF_LAB_FEE')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.entries(_.groupBy(props.data, 'dateOrder')).map((item: any, index: number) => (
                            <>
                                <tr>
                                    <td colSpan={snType ? 12 : 13} style={{ fontSize: '9.5px', fontWeight: 500 }}>
                                        {t('MOMENT_AT')} {` ` + toBuddhistYear(moment(item[0]?.dateOrder), 'DD/MM/YYYY')}
                                    </td>
                                </tr >
                                {item?.[1]?.map((data: any, index: number) => (
                                    <>
                                        <tr key={index}>
                                            <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'top', width: '50px' }}>{index + 1}</td>
                                            <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'top', width: '120px' }}>{data?.doctorName || '-'}</td>
                                            <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'top', width: '85px' }}>{data?.branchCnNumber || '-'}</td>
                                            {snType && <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'top', width: '50px' }}>{data?.snCode || '-'}</td>}
                                            <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'top', width: '150px' }}>{data?.patientName || '-'}</td>
                                            <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'top', width: '150px' }}>{data?.labCompanyName || '-'}</td>
                                            <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'top', width: '100px' }}>{data?.labGroupName || '-'}</td>
                                            <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'top', width: '150px' }}>{data?.labName || '-'}</td>
                                            <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'top', width: '100px' }}>{data?.labRemark || '-'}</td>
                                            <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'top', width: '150px' }}>{data?.operativeName || '-'}</td>
                                            <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'right', verticalAlign: 'top', width: '85px' }}>{numberFormat(data?.labOrderPrice || 0)}</td>
                                            <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'right', verticalAlign: 'top', width: '85px' }}>{`${numberFormat(data?.labDoctorPercent || 0)}%`}</td>
                                            <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'right', verticalAlign: 'top', width: '85px' }}>{numberFormat(data?.labDoctorTotal || 0)}</td>
                                        </tr>
                                    </>
                                ))}
                            </>
                        ))}
                    </tbody>
                </table>
                <br />
                <table style={{ width: '40%', border: '1px solid black', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr style={{ textAlign: 'center', fontSize: '9.5px', fontWeight: 700 }}>
                            <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('#')}</th>
                            <th style={{ borderBottom: '1px solid black', textAlign: 'center' }}>{t('REPORT.TABLE.LAB.LAB_FEE')}</th>
                            <th style={{ borderBottom: '1px solid black', textAlign: 'center' }}>{t('REPORT.TABLE.LAB.DF_LAB_FEE')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.entries(_.groupBy(props.data, 'dateOrder')).map((data: any, index: number) => (
                            <tr key={index}>
                                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'top' }}>{toBuddhistYear(moment(data[0]), 'DD/MM/YYYY')}</td>
                                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'right', verticalAlign: 'top' }}>{numberFormat(_.sumBy(data[1], 'labOrderPrice'))}</td>
                                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'right', verticalAlign: 'top' }}>{numberFormat(_.sumBy(data[1], 'labDoctorTotal'))}</td>
                            </tr>
                        ))}
                        <tr>
                            <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'top' }}>{t('REPORT.TITLE.SUM')}</td>
                            <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'right', verticalAlign: 'top' }}>{numberFormat(_.sumBy(props.data, 'labOrderPrice'))}</td>
                            <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'right', verticalAlign: 'top' }}>{numberFormat(_.sumBy(props.data, 'labDoctorTotal'))}</td>
                        </tr>
                    </tbody>
                </table>
            </Box >
        </>
    )
}

export function LabReportExport(props: ExportProps) {
    const { t } = useTranslation()

    const FILTER_TITLES = [
        { key: 'BRANCH', label: 'REPORT.FILTER.BRANCH' },
        { key: 'DATE_START', label: 'REPORT.FILTER.DATE_START' },
        { key: 'DATE_END', label: 'REPORT.FILTER.DATE_END' },
        { key: 'DOCTOR', label: 'REPORT.FILTER.DOCTOR' },
        { key: 'LAB_GROUP', label: 'REPORT.FILTER.LAB_GROUP' },
        { key: 'LAB_COMPANY', label: 'REPORT.FILTER.LAB_COMPANY' },
    ];

    const renderValue = (value: any, index: any) => {
        if (index === 1 || index === 2) {
            return value ? toBuddhistYear(moment(value), 'DD/MM/YYYY') : '-';
        }
        return value;
    };

    return (
        <>
            <TableHead style={{ fontWeight: 800 }} >{t('REPORT.REPORT_NAME.LAB')}</TableHead>
            <table>
                <tr>
                    {FILTER_TITLES.map((filter, index) => (
                        <TableSortLabel key={index} >
                            <td className='mr-2' style={{ fontSize: 10, fontWeight: 800 }}>{t(filter.label)} : </td>
                            <td style={{ fontSize: 10, fontWeight: 500 }}>{renderValue(props.filter[index], index)}</td>
                        </TableSortLabel >
                    ))}
                </tr>
            </table>
            {props.componant}
        </>
    )
}
